(() => {
  angular
    .module('app')
    .controller('host.views.sendNotifications.page', SendNotificationsPageController);
  SendNotificationsPageController.$inject = [
    '$scope',
    'Hms.Services.ServiceType',
    'abp.services.app.userNotification',
  ];
  function SendNotificationsPageController($scope, enumServiceType, userNotificationSvc) {
    const vm = this;
    vm.loading = 0;
    vm.saving = 0;
    vm.enums = {};

    vm.enums = {
      serviceType: enumServiceType,
    };
    vm.requestParams = {
      serviceType: null,
      previewTitle: null,
      previewMessage: null,
      title: null,
      message: null,
    };

    vm.sendNotifications = sendNotifications;

    $scope.$on('$viewContentLoaded', () => {
      App.initAjax();
    });

    function init() {}

    function sendNotifications() {
      if (
        !vm.requestParams.serviceType ||
        !vm.requestParams.previewTitle ||
        !vm.requestParams.previewMessage ||
        !vm.requestParams.title ||
        !vm.requestParams.message
      ) {
        return false;
      }
      vm.saving += 1;
      userNotificationSvc
        .sendAdhocNotifications(vm.requestParams)
        .success(() => {
          abp.notify.success('Notification jobs queued!');
        })
        .finally(() => {
          vm.saving -= 1;
        });

      return true;
    }

    init();
  }
})();
